class UiHeaderController {
  constructor($rootScope, $state, $translate, $window) {
    "ngInject";
    const vm = this;

    vm.state = $state;
    vm.rootScope = $rootScope;

    /* Language */
    vm.vLanguage = "en";
    if ($window.localStorage.getItem("vLanguage")) {
      vm.vLanguage = $window.localStorage.getItem("vLanguage");
      $translate.use(vm.vLanguage);
    }

    vm.changeLanguage = (key) => {
      vm.vLanguage = key;
      $translate.use(key);
      $window.localStorage.setItem("vLanguage", key);
      $window.location.reload();
    };
  }
}

export default UiHeaderController;



// WEBPACK FOOTER //
// ./client/app/common/uiHeader/uiHeader.controller.js